const STORAGE_KEY = 'postLoginRedirect';

// Paths a user should never be sent back to after signing in
const EXCLUDED_PATHS = ['/', '/login', '/404'];
const EXCLUDED_PREFIXES = ['/resetpassword', '/setpassword'];

// Remember the page an unauthenticated user was trying to reach so we can
// send them there after they sign in. sessionStorage keeps it per-tab and
// lets it survive a refresh of the login screen.
export const saveLoginRedirect = (pathname: string, search: string = ''): void => {
  if (!pathname || EXCLUDED_PATHS.includes(pathname)) return;
  if (EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return;
  sessionStorage.setItem(STORAGE_KEY, `${pathname}${search}`);
};

export const consumeLoginRedirect = (): string | null => {
  const redirect = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  // Only internal paths are valid redirect targets
  return redirect && redirect.startsWith('/') ? redirect : null;
};
